module.exports = __webpack_public_path__ + "img/essui.47e81945.jpg";